import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { SendFromStore } from 'widgets/SendFrom'

export class RcsFallbackStore {
  readonly sendFromStore: SendFromStore
  private _disposeReaction: IReactionDisposer | null = null

  constructor(private _entities: IEntitiesStore) {
    this.sendFromStore = new SendFromStore(this._entities, {
      onChangeInboxId: async (id) => {
        if (!id) return
        if (!this._entities.rcsStore.rcs) await this._entities.rcsStore.init()
        this._entities.rcsStore.onUpdate({ id })
      },
    })

    makeAutoObservable(this)
    this._initReaction()
  }

  init = async () => {
    const { rcsStore } = this._entities

    if (rcsStore.rcs?.fallbackInboxId) {
      await this.sendFromStore.setSelectItem({ inbox_id: rcsStore.rcs.fallbackInboxId })
    }

    if (rcsStore.rcs) return

    await rcsStore.init()
  }

  private _initReaction = () => {
    this._disposeReaction?.()
    this._disposeReaction = reaction(
      () => this._entities.rcsStore.rcs?.fallbackInboxId,
      (fallbackInboxId) => {
        if (fallbackInboxId) this.sendFromStore.setSelectItem({ inbox_id: fallbackInboxId })
      }
    )
  }

  dispose = () => {
    this._disposeReaction?.()
  }
}
